/* eslint-disable */

export enum Channel {
  CHANNEL_UNSPECIFIED = "CHANNEL_UNSPECIFIED",
  CHANNEL_IN_STORE = "CHANNEL_IN_STORE",
  CHANNEL_ONLINE = "CHANNEL_ONLINE",
  CHANNEL_IN_APP = "CHANNEL_IN_APP",
}
